import React from "react";
import ActivityForm from "./componenets/ActivityForm/ActivityForm";
import "./dcr-form.scss";

const DCRForm = (config) => {
  return (
    <div className="dcrform">
      <ActivityForm {...config}/>
    </div>
  );
};

export default DCRForm;
